export class Pricing {

    constructor(
        public name: string,
        public currency: string,
        public planId: string,
        public productId: string,
        public mainPrice: string) {
    }
}